import React from "react"
import { Typography, Box } from "@material-ui/core"
import DisplayChild from "./DisplayChild"

function Display({ name, interest, amount, years }) {
  const formatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 0,
  })

  const calculateMonthlyRepayment = () => {
    const potencial = ["UNO", "MERCADO"].includes(name) ? 365 : 1
    const monthlyRepayment =
      amount * (1 + interest / 100 / 365) ** (years * potencial)
    return (
      <Typography variant="h4">
        <strong>{formatter.format(monthlyRepayment)}</strong>
      </Typography>
    )
  }

  const percentageAPR = () => {
    return (
      <Typography variant="h4">
        <strong>{interest}%</strong>
      </Typography>
    )
  }

  return (
    <Box display="flex" justifyContent="space-between">
      <DisplayChild
        func={calculateMonthlyRepayment()}
        text="Retorno Estimado"
      />
    </Box>
  )
}

export default Display
